if (!customElements.get('sp-category-scroll')) {
  customElements.define('sp-category-scroll', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const list = this.querySelector('.sp-mobile-categories__links');
      if (!list) return;
      const media = matchMedia('(max-width: 999px)');
      const key = 'sp:category-scroll:' + this.dataset.family;
      let saved = 0;
      let selectedHref = null;
      let interacted = false;
      try {
        const state = JSON.parse(sessionStorage.getItem(key));
        const value = Number(state && typeof state === 'object' ? state.left : state);
        if (Number.isFinite(value) && value >= 0) saved = value;
        if (state && typeof state.href === 'string') selectedHref = state.href;
      } catch {}
      const selectionInset = 38;
      const alignPosition = link => Math.max(0, Math.min(
        list.scrollLeft + link.getBoundingClientRect().left - list.getBoundingClientRect().left - list.clientLeft - selectionInset,
        list.scrollWidth - list.clientWidth
      ));
      const restore = () => {
        if (!this.isConnected || !media.matches || interacted) return;
        const selected = selectedHref && [...list.querySelectorAll('a[href]')].find(link => link.getAttribute('href') === selectedHref);
        list.scrollLeft = selected ? alignPosition(selected) : saved;
      };
      const save = () => {
        if (!media.matches) return;
        try {
          sessionStorage.setItem(key, selectedHref ? JSON.stringify({left:list.scrollLeft,href:selectedHref}) : String(list.scrollLeft));
        } catch {}
      };
      const interact = () => { interacted = true; selectedHref = null; };
      const alignSelection = event => {
        if (!media.matches || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target?.closest?.('a[href]');
        if (!link || !list.contains(link) || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
        interacted = true;
        selectedHref = link.getAttribute('href');
        list.scrollLeft = alignPosition(link);
        save();
      };
      list.addEventListener('scroll', save, {...options,passive:true});
      list.addEventListener('click', alignSelection, options);
      list.addEventListener('pointerdown', interact, {...options,passive:true});
      list.addEventListener('touchstart', interact, {...options,passive:true});
      list.addEventListener('wheel', interact, {...options,passive:true});
      list.addEventListener('keydown', interact, options);
      window.addEventListener('pagehide', save, options);
      media.addEventListener('change', restore, options);
      restore();
      this.frame = requestAnimationFrame(restore);
      document.fonts?.ready.then(restore);
      this.setAttribute('data-sp-scroll-ready', 'true');
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

